// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.device_channel_role_enum */
var DeviceChannelRoleEnum;
(function (DeviceChannelRoleEnum) {
    DeviceChannelRoleEnum["TELEMETRY"] = "TELEMETRY";
    DeviceChannelRoleEnum["SETPOINT"] = "SETPOINT";
    DeviceChannelRoleEnum["OUTPUT"] = "OUTPUT";
    DeviceChannelRoleEnum["DIAGNOSTIC"] = "DIAGNOSTIC";
})(DeviceChannelRoleEnum || (DeviceChannelRoleEnum = {}));
;
export default DeviceChannelRoleEnum;
/** Zod schema for device_channel_role_enum */
export const deviceChannelRoleEnum = z.nativeEnum(DeviceChannelRoleEnum);
//# sourceMappingURL=DeviceChannelRoleEnum.js.map